import { LoadingButton } from "@mui/lab";
import {
  Backdrop,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  Select,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Box } from "@mui/system";
import { AxiosInstance } from "axios";
import { Dispatch, FC, Fragment, useEffect, useState } from "react";
import { AllMounth, yearsToDisplay } from "../../../constants/Constants";
import { DataRef } from "../../../types/DataRef";
import CheckAttr from "../../../utils/CheckAttr";
import { DataArticle } from "../SaisieManager/AddSaisieAgentForm";
import { useStyles } from "../styles";
import AddprevisionnelQtRow from "./AddprevisionnelQtRow";
import {
  ArticleWithPrev,
  IPrevToSave,
  PrevisionnelSum,
} from "./IPrevisionnelQtArticle";
import SaveIcon from "@mui/icons-material/Save";
import { AlertType } from "../../../types/AlertType";

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#fff",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#080d24",
    color: theme.palette.common.white,
    fontSize: 11,
    textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "center",
    fontWeight: "bold",
  },
}));

interface AddPrevisionnelQtProps {
  dataPaysInAssociations: DataRef[];
  http: AxiosInstance;
  onClose: () => void;
  reloadList: () => void;
  setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<React.SetStateAction<string>>;
  setAlertType: Dispatch<React.SetStateAction<AlertType>>;
}

const initialPrevsumAnnuel: PrevisionnelSum = {
  sommeprevA: 0,
  sommePrevH: 0,
};

const AddPrevisionnelQt: FC<AddPrevisionnelQtProps> = ({
  dataPaysInAssociations,
  http,
  onClose,
  setOpenSnack,
  setAlerteMessage,
  setAlertType,
  reloadList
}) => {
  const classes = useStyles();

  // ###### Input Selected
  const [idPaysSelected, setIdPaysSelected] = useState<Number>(0);
  const [idClientSelected, setIdClientSelected] = useState<Number>(0);
  const [idOperationSelected, setIdOperationSelected] = useState<Number>(0);
  const [mounthSelected, setMounthSelected] = useState<Number>();
  const [yearSelected, setYearSelected] = useState<Number>();

  const [isClickSave, setIsClickSave] = useState<boolean>(false);

  const [dataClients, setDataClients] = useState<DataRef[]>([]);
  const [dataOperations, setDataOperations] = useState<DataRef[]>([]);
  const [dataArticles, setDataArticles] = useState<DataArticle[]>([]);

  // Data To Save
  const [dataPrevTosave, setDataPrevToSave] = useState<IPrevToSave[]>([]);

  // data Article with Prev
  const [dataArticlesWithPrev, setDataArticlesWithPrev] = useState<
    ArticleWithPrev[]
  >([]);
  const [annuellePrev, setAnnuellePrev] =
    useState<PrevisionnelSum>(initialPrevsumAnnuel);

  // Autre
  const [loader, setLoader] = useState(false);

  // Somme
  const [sumMensuelprevheure, setSumMensuelPrevHeure] = useState<Number>();
  const [sumMensuelprevheureSaisie, setSumMensuelPrevHeureSaisie] =
    useState<Number>(0);
  const [sumMensuelprevheureTotal, setSumMensuelPrevHeureTotal] =
    useState<Number>(0);
  const [sumMensuelprevActe, setSumMensuelprevActe] = useState<Number>(0);
  const [sumMensuelprevActeSaisie, setSumMensuelPrevActeSaisie] =
    useState<Number>(0);
  const [sumMensuelprevActeTotal, setSumMensuelPrevActeTotal] =
    useState<Number>(0);

  // Get data Ref #############
  const getClientByPays = (idPaysTemp: Number) => {
    // Récupère les clients du pays sélectionné
    setLoader(true);
    http
      .get(`client/get-clients-via-pays/${idPaysTemp}`)
      .then((res) => {
        Array.isArray(res.data) && setDataClients(res.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getOperationByClientPays = (idClientTemp: Number) => {
    // Recupere les operation du pays et client
    setLoader(true);
    http
      .get(
        `operation/get-operations/via-pays-client/${idPaysSelected}/${idClientTemp}`
      )
      .then((res) => {
        Array.isArray(res.data) && setDataOperations(res.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  // Use Effect
  useEffect(() => {
    if (
      CheckAttr(yearSelected) &&
      CheckAttr(mounthSelected) &&
      CheckAttr(idPaysSelected) &&
      CheckAttr(idClientSelected) &&
      CheckAttr(idOperationSelected)
    ) {
      // setBudgetToSave({ ...budgetToSave, rows: [] });
      const data = {
        pays: idPaysSelected,
        operation: idOperationSelected,
        mounth: mounthSelected,
        year: yearSelected,
      };
      // setLoader(true);
      // Récupère les opérations
      setLoader(true);
      setSumMensuelPrevHeure(0);
      setSumMensuelPrevHeureSaisie(0);
      setSumMensuelPrevActeSaisie(0);
      setSumMensuelprevActe(0);
      http
        .post("article/findby-pays-client-operation/previsionnel", data)
        .then((res) => {
          setDataArticlesWithPrev(res.data.articles);
          setAnnuellePrev(res.data.previsionnelSumActe);
          // Enlever Les Article Sans Prev
          const tmp: ArticleWithPrev[] = res.data.articles.filter(
            (art: ArticleWithPrev) => art.previsionneleQT.length !== 0
          );
          setSumMensuelPrevHeure(
            tmp?.reduce(
              (res, curr) =>
                res + Number(curr?.previsionneleQT[0]?.heure_prev) || 0,
              0
            )
          );

          setSumMensuelprevActe(
            tmp?.reduce(
              (res, curr) =>
                res + Number(curr?.previsionneleQT[0]?.acte_prev) || 0,
              0
            )
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setLoader(false);
        });
    } else {
      setDataArticlesWithPrev([]);
    }
  }, [
    yearSelected,
    mounthSelected,
    idClientSelected,
    idOperationSelected,
    idPaysSelected,
  ]);

  useEffect(() => {
    // Mise A jour Somme
    if (Number(sumMensuelprevheure) && Number(sumMensuelprevheureSaisie)) {
      setSumMensuelPrevHeureTotal(
        Number(sumMensuelprevheure) + Number(sumMensuelprevheureSaisie)
      );
    } else if (Number(sumMensuelprevheure)) {
      setSumMensuelPrevHeureTotal(Number(sumMensuelprevheure));
    } else if (Number(sumMensuelprevheureSaisie)) {
      setSumMensuelPrevHeureTotal(Number(sumMensuelprevheureSaisie));
    } else {
      setSumMensuelPrevHeureTotal(0);
    }

    console.log(Number(sumMensuelprevActe));
    console.log(Number(sumMensuelprevActeSaisie));

    if (Number(sumMensuelprevActe) && Number(sumMensuelprevActeSaisie)) {
      setSumMensuelPrevActeTotal(
        Number(sumMensuelprevActe) + Number(sumMensuelprevActeSaisie)
      );
    } else if (Number(sumMensuelprevActe)) {
      setSumMensuelPrevActeTotal(Number(sumMensuelprevActe));
    } else if (Number(sumMensuelprevActeSaisie)) {
      setSumMensuelPrevActeTotal(Number(sumMensuelprevActeSaisie));
    } else {
      setSumMensuelPrevActeTotal(0);
    }
  }, [
    sumMensuelprevheureSaisie,
    sumMensuelprevheure,
    sumMensuelprevActeSaisie,
    sumMensuelprevActe,
  ]);

  let showOperations = false;
  if (
    CheckAttr(yearSelected) &&
    CheckAttr(mounthSelected) &&
    CheckAttr(idPaysSelected) &&
    CheckAttr(idClientSelected) &&
    CheckAttr(idOperationSelected) &&
    dataArticlesWithPrev.length !== 0
  ) {
    showOperations = true;
  }

  // HandleChanve

  const handeChangePrevisionnelTosave = (prevToSavefront: IPrevToSave) => {
    let dataPrevTosaveDefault: IPrevToSave[] = dataPrevTosave;
    console.log("okok");

    if (
      dataPrevTosaveDefault.find(
        (prev) => prev.articleId == prevToSavefront.articleId
      )
    ) {
      // Udpate
      const index = dataPrevTosaveDefault.findIndex(
        (p) => p.articleId == prevToSavefront.articleId
      );

      dataPrevTosaveDefault[index] = prevToSavefront;
    } else {
      // Create
      dataPrevTosaveDefault.push(prevToSavefront);
    }
    console.log(dataPrevTosaveDefault);
    setSumMensuelPrevHeureSaisie(
      dataPrevTosaveDefault?.reduce(
        (res, curr) => Number(res) + (Number(curr?.heure_prev) || 0) || 0,
        0
      )
    );

    setSumMensuelPrevActeSaisie(
      dataPrevTosaveDefault?.reduce(
        (res, curr) => Number(res) + (Number(curr?.acte_prev) || 0) || 0,
        0
      )
    );

    setDataPrevToSave(dataPrevTosaveDefault);
  };

  // handle Save
  const handleSave = () => {
    const dataToSave = {
      annee: yearSelected,
      mois: mounthSelected,
      previsionnel: dataPrevTosave,
    };

    console.log(dataToSave);

    // teste Si il y a aucun  A enregister
    if (dataPrevTosave.length == 0) {
      setAlerteMessage("Merci de parametrer un budget parmi ceux qui sont encore vide SVP !");
      setAlertType("warning");
      setOpenSnack(true);
    } else {
      setIsClickSave(true);
      http
        .post(`forecast/save`, dataToSave)
        .then((res) => {
          if (typeof res.data === "string") {
            setAlerteMessage(res.data);
            setAlertType("warning");
            setOpenSnack(true);
        }
        else{
            setAlerteMessage("Enregistrement efféctuée !");
            setAlertType("success");
            setOpenSnack(true);
            reloadList();
            onClose();
        }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setIsClickSave(false);
        });
    }
  };

  return (
    <Fragment>
      <Box className={classes.root} mb={3}>
        <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 12 }}>
          <Grid item xs={6} sm={6} md={6}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="pays"
                color="warning"
                shrink={CheckAttr(idPaysSelected) && idPaysSelected !== 0}
              >
                Pays de production
              </InputLabel>
              <Select
                id="pays"
                native
                color="warning"
                value={idPaysSelected}
                onChange={(e) => {
                  setIdPaysSelected(e.target.value as Number);
                  getClientByPays(e.target.value as Number);

                  setDataClients([]);
                  setIdClientSelected(0);

                  setDataOperations([]);
                  setIdOperationSelected(0);
                }}
                label="Pays de production"
                inputProps={{
                  name: "pays",
                }}
              >
                <option value=""></option>
                {dataPaysInAssociations.map((pays) => (
                  <option key={pays?.id} value={pays?.id}>
                    {pays?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="operation"
                color="warning"
                shrink={
                  CheckAttr(idOperationSelected) && idOperationSelected !== 0
                }
              >
                Opération
              </InputLabel>
              <Select
                id="operation"
                native
                color="warning"
                value={idOperationSelected}
                onChange={(e) => {
                  setIdOperationSelected(e.target.value as Number);
                  console.log(e.target.value as Number);
                }}
                label="Opération"
                inputProps={{
                  name: "operation",
                }}
              >
                <option value=""></option>
                {dataOperations.map((operation) => (
                  <option key={operation?.id} value={operation?.id}>
                    {operation?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="client"
                color="warning"
                shrink={CheckAttr(idClientSelected) && idClientSelected !== 0}
              >
                Client
              </InputLabel>
              <Select
                id="client"
                native
                color="warning"
                value={idClientSelected}
                onChange={(e) => {
                  setIdClientSelected(e.target.value as Number);
                  getOperationByClientPays(e.target.value as Number);

                  setDataOperations([]);
                  setIdOperationSelected(0);
                }}
                label="Client"
                inputProps={{
                  name: "client",
                }}
              >
                <option value=""></option>
                {dataClients.map((client) => (
                  <option key={client?.id} value={client?.id}>
                    {client?.libelle}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 12 }}>
          <Grid item xs={6} sm={6} md={6}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="year"
                color="warning"
                shrink={CheckAttr(yearSelected)}
              >
                Année
              </InputLabel>
              <Select
                id="year"
                native
                color="warning"
                value={yearSelected}
                onChange={(e) => {
                  setYearSelected(e.target.value as Number);
                }}
                label="Année"
                inputProps={{
                  name: "year",
                }}
              >
                <option value={0}></option>
                {yearsToDisplay.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="month"
                color="warning"
                shrink={CheckAttr(mounthSelected)}
              >
                Mois
              </InputLabel>
              <Select
                id="month"
                native
                color="warning"
                value={mounthSelected}
                onChange={(e) => {
                  setMounthSelected(e.target.value as Number);
                }}
                label="Mois"
                inputProps={{
                  name: "month",
                }}
              >
                <option value=""></option>
                {AllMounth.map((month) => (
                  <option key={month?.id} value={month?.id}>
                    {month?.mounth}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>

      {showOperations && (
        <>
          <TableContainer sx={{ mt: 4 }}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Codes article</StyledTableCell>
                  <StyledTableCell>Articles / Désignation</StyledTableCell>
                  <StyledTableCell>Forecast Heures</StyledTableCell>
                  <StyledTableCell>Forecast Actes</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataArticlesWithPrev.map((article) => (
                  <AddprevisionnelQtRow
                    article={article}
                    handeChangePrevisionnelTosave={
                      handeChangePrevisionnelTosave
                    }
                  />
                ))}
                <StyledTableRow>
                  <StyledTableCell />
                  <StyledTableCell />
                  <StyledTableCell />
                  <StyledTableCell />
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell>Total du mois</StyledTableCell>
                  <StyledTableCell />
                  <StyledTableCell>
                    {sumMensuelprevheureTotal &&
                      parseFloat(String(sumMensuelprevheureTotal))?.toFixed(2)}
                  </StyledTableCell>
                  <StyledTableCell>
                    {sumMensuelprevActeTotal &&
                      parseFloat(String(sumMensuelprevActeTotal))?.toFixed(2)}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell>Total de l’année</StyledTableCell>
                  <StyledTableCell />
                  <StyledTableCell></StyledTableCell>
                  <StyledTableCell></StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Box display="flex" justifyContent="center" mt={5}>
            <LoadingButton
              onClick={() => handleSave()}
              endIcon={<SaveIcon />}
              loading={isClickSave}
              loadingPosition="end"
              sx={{ textTransform: "none" }}
              variant="contained"
              color="warning"
            >
              Enregistrer
            </LoadingButton>
          </Box>
        </>
      )}
      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </Fragment>
  );
};

export default AddPrevisionnelQt;
